import { render } from "./Send.m.vue?vue&type=template&id=19a92a82"
import script from "./Send.m.vue?vue&type=script&lang=js"
export * from "./Send.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__